const KST_TIME_ZONE = 'Asia/Seoul'

/** Date → `<input type="datetime-local">` 값(YYYY-MM-DDTHH:mm, 한국 시각). 런타임 timezone과 무관하다. */
export function toKstDateTimeInputValue(date: Date): string {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: KST_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(date)
  const get = (type: Intl.DateTimeFormatPartTypes) => parts.find((p) => p.type === type)?.value ?? ''
  return `${get('year')}-${get('month')}-${get('day')}T${get('hour')}:${get('minute')}`
}

/** 한국 시각 datetime-local 값 → +09:00 offset ISO 문자열. 형식이 다르면 null. */
export function kstDateTimeInputToIso(value: string): string | null {
  if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(value)) return null
  return `${value}:00+09:00`
}

/** offset ISO 문자열을 한국 시각으로 표시한다(예: 2026. 10. 22. 14:30). */
export function formatKstDateTime(iso: string, locale: string): string {
  return new Intl.DateTimeFormat(locale, {
    timeZone: KST_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).format(new Date(iso))
}
